import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

function InputRange() {
  const self = this;

  self.init = function init(element) {
    const $wrap = $(element);

    if ($wrap.data('app-module-initialized')) return; // Prevent double init

    const $scale = $wrap.find('.js-input-range__scale');
    const $fieldMin = $wrap.find('.js-input-range__min');
    const $fieldMax = $wrap.find('.js-input-range__max');

    const min = parseInt($wrap.data('range-min'), 10) || 0;
    const max = parseInt($wrap.data('range-max'), 10) || 100;
    const step = parseInt($wrap.data('range-step'), 10) || 10;
    const margin = parseInt($wrap.data('range-margin'), 10) || step;

    const startMin = parseInt($fieldMin.val(), 10) || min;
    const startMax = parseInt($fieldMax.val(), 10) || max;

    if ($fieldMin.length !== 0 && $fieldMax.length !== 0 && $scale.length !== 0) {
      noUiSlider.create($scale[0], {
        start: [startMin, startMax],
        step,
        margin,
        connect: true,
        range: {
          min,
          max,
        },
        tooltips: true,
        format: wNumb({
          decimals: 0,
          thousand: '',
        }),
      });

      $scale[0].noUiSlider.on('update', (values, handle) => {
        const value = values[handle];
        if (handle) {
          $fieldMax[0].value = value;
        } else {
          $fieldMin[0].value = value;
        }
      });

      $scale[0].noUiSlider.on('change', () => {
        $fieldMin.change();
      });

      $fieldMin.on('change', () => {
        $scale[0].noUiSlider.set([$fieldMin.val(), null]);
      });

      $fieldMax.on('change', () => {
        $scale[0].noUiSlider.set([null, $fieldMax.val()]);
      });
    }

    $wrap.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-input-range').each(function init() {
      self.init(this);
    });
  };
}

export default new InputRange();
